/**
 * The preview widths a prototype is reviewed at: a phone, a tablet, and the
 * full pane. Shared by the prototype page and the case file's in-place review.
 */
export type Viewport = "mobile" | "tablet" | "full";

export const VIEWPORT_WIDTH: Record<Viewport, number | undefined> = {
  mobile: 390,
  tablet: 768,
  full: undefined,
};

const VIEWPORT_LABEL: Record<Viewport, string> = {
  mobile: "Mobile",
  tablet: "Tablet",
  full: "Full",
};

export function ViewportToggle({
  value,
  onChange,
}: {
  value: Viewport;
  onChange: (viewport: Viewport) => void;
}) {
  return (
    <div className="flex items-center gap-1" role="group" aria-label="Preview viewport">
      {(Object.keys(VIEWPORT_LABEL) as Viewport[]).map((vp) => (
        <button
          key={vp}
          type="button"
          onClick={() => onChange(vp)}
          aria-pressed={value === vp}
          className={`px-2.5 py-1 rounded-[var(--radius-stamp)] font-mono text-[10.5px] uppercase tracking-wide transition-colors ${
            value === vp
              ? "bg-[var(--accent-muted)] text-[var(--accent)]"
              : "text-[var(--text-tertiary)] hover:text-[var(--text-secondary)]"
          }`}
        >
          {VIEWPORT_LABEL[vp]}
        </button>
      ))}
    </div>
  );
}
